module.exports = __webpack_public_path__ + "img/bank.7b9d4274.svg";